import { DisplayProperties } from '@com-delta-omnichannel/aura';
import { AEMErrorMessage } from '../models';
import { getEmptyContent } from './adapter.utils';

// 📑 Validate object types
export const isType = <T>(feature: T, property: string): feature is T => {
  return (feature as T)[property as keyof T] !== undefined;
};

// 📑 Validate if the data is not undefined
//    Can receive or not the Generic types as `isExist<[User, Car]>(user, car);`
//    or as `isExist(user, car);`
export const isExist = <T extends unknown[]>(...data: T): boolean => {
  return data.filter((content) => content === undefined).length === 0;
};

export const isValidObject = <T>(
  data: T,
  propertyToValidate: string
): boolean => {
  return typeof data === 'object' ? isType<T>(data, propertyToValidate) : true;
};

// 📑 Parameters to validate data objects, mainly for use in the adapters
//    1. Property from the object to validate
//    2. Object to validate if is valid or not
//    3. Rest of params
export const isValidData = <T, U extends unknown[]>(
  propertyToValidate: string,
  ...data: U
): boolean => {
  const validData = isExist(...data);
  const validType = isValidObject<T>(data[0] as T, propertyToValidate);
  return validData && validType;
};

export const isDisplay = <T extends DisplayProperties>(
  flag: boolean | undefined
): T => {
  return flag === false
    ? getEmptyContent<T>('', [], true, true)
    : getEmptyContent<T>();
};

export const isError = <T extends DisplayProperties>(
  error: string,
  aemErrorMessages: AEMErrorMessage[] | undefined,
  flag: boolean | undefined
): T => {
  return flag === false
    ? getEmptyContent<T>('', [], true, true)
    : flag === true
    ? getEmptyContent<T>(error, aemErrorMessages, true)
    : getEmptyContent<T>();
};
